import "./MediaItemsModel.scss"
import React, {useState} from "react";
import Fancybox from "../../../raikoComponents/fancybox/Fancybox";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import ThumborHelper from "../../../util/ThumborHelper";
import {fileTypes} from "../../../component/fileManager/FileManager";
import apkImage from '../../../assets/svg/android_os.svg'
import audioIcon from "../images/ic_audio.svg"
import {css} from "@emotion/css";
import {MediaPlayer, MediaProvider} from "@vidstack/react";
import {FileManagerService} from "../../../component/fileManager/FileManagerService";
import {
    convertCurrencyFormatPositiveNegative,
    convertUniversalDateTimeToPersianDateTime, convertUniversalDateToPersianDate,
    RaikoConfirmDialog, RaikoCustomTooltip, RaikoGridOneColumn, RaikoLabel,
    showErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";

export default function MediaItemsModel(
    {
        id,
        name,
        url,
        size,
        uploadedAt,
        uploadedBy,
        type,
        refreshList,
        isSelector = false,
        onClick,
        fileManagerUrl
    }
) {

    const loading = new LoadingHelper(useLoadingDispatcher())

    const service = new FileManagerService()

    function getPreviewByType() {
        switch (type) {
            case fileTypes.IMAGE:
                return imagePreview()
            case fileTypes.APK:
                return apkPreview()
            case fileTypes.VIDEO:
                return videoPreview()
            case fileTypes.AUDIO:
                return audioPreview()
        }
    }

    function imagePreview() {
        return <div className={"imageContainer"}>
            <Fancybox
                options={{
                    Carousel: {
                        infinite: false,
                    },
                }}
            >
                <a href={url} data-fancybox={"gallery"}
                   data-caption={` بارگزاری شده توسط ${uploadedBy} در تاریخ ${convertUniversalDateTimeToPersianDateTime(uploadedAt)}`}>
                    <img
                        src={new ThumborHelper.Builder(url).setImageCompressSize(100, 100).changeQuality(10).convertWebp().build()}
                        alt={name}/>
                    <div>
                        <div className={"zoom_icon"}/>
                    </div>
                </a>
            </Fancybox>
        </div>;
    }

    function videoPreview() {
        return <div
            className={`videoPreviewContainer`}>
            <MediaPlayer
                title={name}
                src={url.replace("http:", "https:")}
                aspectRatio={"1/1"}
            >
                <MediaProvider/>
            </MediaPlayer>
        </div>
    }

    function audioPreview() {
        return <div className={"imageContainer"}>
            <img src={audioIcon} alt={name} className={css`padding: .75rem`}/>
        </div>
    }

    function apkPreview() {
        return <div className={"imageContainer"}>
            <img src={apkImage} alt={name} className={css`padding: .75rem`}/>
        </div>
    }

    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);


    function handleDeleteDialog() {

        loading.show()
        service.deleteFile(id,fileManagerUrl)
            .then(response => {
                showSuccessMessage("فایل با موفقیت حذف شد")
                setOpenDeleteDialog(false)
                refreshList()
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    return (
        <>
            <RaikoConfirmDialog
                openConfirmDialog={openDeleteDialog}
                cancelAction={_ => {
                    setOpenDeleteDialog(false)
                }}
                doAction={handleDeleteDialog}
                pageTitle={"حذف آیتم"}

            />

            <div
                className={`mediaItemsPictureContainer ${isSelector ? css`background: var(--color-surface) !important;` : ""}`}
                onClick={_ => {
                    if (isSelector) {
                        onClick()
                    }
                }}
            >
                <div className={"mediaInfoContainer"}>
                    <div onClick={event => {
                        event.stopPropagation()
                    }}>
                        {
                            getPreviewByType()
                        }
                    </div>
                    <RaikoGridOneColumn className={css`gap: .5rem`}>
                        <RaikoLabel text={name} className={css`font-size: var(--text-size-default)`}/>
                        <div className={"mediaShortInfoContainer"}>
                            <div className={"dateContainer"}>
                                <div className={"ic-time"}/>
                                <RaikoLabel text={convertUniversalDateToPersianDate(uploadedAt)}/>
                            </div>
                            <div className={"sizeContainer"}>
                                <RaikoLabel
                                    text={"KB"}
                                />
                                <RaikoLabel
                                    text={convertCurrencyFormatPositiveNegative(Math.ceil(size / 1024))}
                                />
                            </div>
                        </div>
                    </RaikoGridOneColumn>
                </div>
                <div className={`accessItemsContainer ${isSelector && css`display: none !important`}`}>
                    <div className="lineVisible ic-line"/>

                    <a href={url} download={true} target={"_blank"} rel={"noreferrer"}>
                        <RaikoCustomTooltip title="دانلود">
                            <button className="btnAccess download-icon"/>
                        </RaikoCustomTooltip>
                    </a>
                    <RaikoCustomTooltip title="کپی لینک">
                        <button
                            onClick={_ => {
                                navigator.clipboard.writeText(url)
                                    .then(_ => {
                                        showSuccessMessage("لینک ویدیو با موفقیت کپی شد.")
                                    }).catch(_ => {
                                    showErrorMessage("خطا در کپی کردن لینک ویدیو!")
                                })
                            }}
                            className="btnAccess share-link-icon"/>
                    </RaikoCustomTooltip>
                    <RaikoCustomTooltip title="حذف">
                        <button onClick={_ => {
                            setOpenDeleteDialog(true)
                        }} className="btnAccess delete-icon"/>
                    </RaikoCustomTooltip>
                </div>
            </div>
        </>
    )
}